<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Lista de Usuarios</p>
    </div>
    <div class="row filtros-container">
      <div class="col-md-2 col-xs-12 filtro-item">
        <lista-unidades-select v-model="unidade" />
      </div>
      <div class="col-md-2 col-xs-12 filtro-item">
        <q-input label="GHE" dense outlined v-model="filtros.ghe" />
      </div>
      <div class="col-md-2 col-xs-12 filtro-item">
        <q-input label="Cargo" dense outlined v-model="filtros.cargo" />
      </div>
      <div class="col-md-2 col-xs-12 filtro-item">
        <q-input label="Centro" dense outlined v-model="filtros.centro" />
      </div>
      <div class="col-md-2 col-xs-12 filtro-item">
        <q-select
          outlined
          dense
          v-model="filtros.biometria"
          :options="options"
          label="Biometria"
        />
      </div>

      <div class="col-xs-12 botoes-container">
        <q-btn
          color="primary"
          class="botao-acao"
          label="Todas as Unidades"
          @click="todasUnidades++"
          no-caps
        />
        <q-btn
          color="primary"
          icon="refresh"
          label="Atualizar Biometria"
          class="botao-acao"
          no-caps
          @click="atualizarTemplatesBiometria"
        />
        <q-btn
          color="primary"
          icon="filter_alt"
          label="Filtrar"
          class="botao-acao"
          no-caps
          @click="filtrarBotao++"
        />
        <q-btn
          v-if="filtrosAtivos"
          color="brand-1"
          icon="refresh"
          label="Limpar Filtros"
          class="botao-acao"
          no-caps
          @click="limparFiltrosFunc()"
        />
      </div>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      align="justify"
    >
      <q-tab
        name="usuarios"
        :label="`Lista de Usuarios${
          totalUsuarios !== null ? ' (' + totalUsuarios + ')' : ''
        }`"
      />
      <q-tab
        name="afastados"
        :label="`Usuarios Afastados${
          totalAfastados !== null ? ' (' + totalAfastados + ')' : ''
        }`"
      />
      <q-tab
        name="desligados"
        :label="`Usuarios Desligados${
          totalDesligados !== null ? ' (' + totalDesligados + ')' : ''
        }`"
      />
    </q-tabs>

    <div v-show="tab === 'usuarios'" class="q-tab-panel-content">
      <TabelaUsuarios
        :unidades="todasUnidades"
        :filtros="filtros"
        :atualizar="filtrarBotao"
        @update:total="totalUsuarios = $event"
      />
    </div>
    <div v-show="tab === 'afastados'" class="q-tab-panel-content">
      <tabela-afastados
        :unidades="todasUnidades"
        @update:total="totalAfastados = $event"
      />
    </div>
    <div v-show="tab === 'desligados'" class="q-tab-panel-content">
      <tabela-usuarios-desligados @update:total="totalDesligados = $event" />
    </div>
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useRouter, useRoute } from "vue-router";
import { onMounted, onActivated, watch } from "vue";
import { useQuasar } from "quasar";
import TabelaUsuarios from "../components/TableUsuarios.vue";
import TabelaAfastados from "../components/TableUsuariosAfastados.vue";
import TabelaUsuariosDesligados from "../components/TableUsuariosDesligados.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useStore } from "vuex";
import { useFilterPersistence } from "../../../../composables/useFilterPersistence";

export default {
  components: {
    TabelaUsuarios,
    TabelaAfastados,
    TabelaUsuariosDesligados,
    ListaUnidadesSelect,
  },
  setup() {
    const filtros = ref({
      ghe: "",
      cargo: "",
      centro: "",
      biometria: "Todos",
    });
    const todasUnidades = ref(0);
    const filtrarBotao = ref(0);
    const quasar = useQuasar();
    const router = useRouter();
    const route = useRoute();
    const tab = ref("usuarios");
    const store = useStore();
    const unidade = ref();
    const totalUsuarios = ref(null);
    const totalAfastados = ref(null);
    const totalDesligados = ref(null);

    const STORAGE_KEY = "usuarios-lista-filtros";

    const {
      salvarFiltros,
      carregarFiltros: carregarFiltrosComposable,
      limparFiltros: limparFiltrosComposable,
      filtrosAtivos: filtrosAtivosComposable,
    } = useFilterPersistence(
      STORAGE_KEY,
      { filtros },
      {
        filtros: {
          ghe: "",
          cargo: "",
          centro: "",
          biometria: "Todos",
          pesquisa: "",
          filtrar: "",
        },
      }
    );

    const filtrosAtivos = filtrosAtivosComposable;

    const carregarFiltros = () => {
      carregarFiltrosComposable();
    };

    const limparFiltrosFunc = ({ recarregar = true } = {}) => {
      limparFiltrosComposable();
      filtros.value = {
        ghe: "",
        cargo: "",
        centro: "",
        biometria: "Todos",
        pesquisa: "",
        filtrar: "",
      };
      if (recarregar) filtrarBotao.value++;
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(() => {
      getUnidade();
      carregarFiltros();
    });

    onActivated(() => {
      carregarFiltros();
    });

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        quasar.notify({
          message: "Atualizando templates de biometria..",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        filtrarBotao.value++;
      } catch (error) {
        quasar.notify({
          message: "Erro ao atualizar templates de biometria",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    watch(
      () => filtros.value,
      () => {
        salvarFiltros();
      },
      { deep: true }
    );

    watch(
      () => tab.value,
      () => {
        router.push({
          path: route.path,
          query: { page: 1 },
        });
      }
    );

    return {
      filtros,
      todasUnidades,
      unidade,
      filtrarBotao,
      tab,
      atualizarTemplatesBiometria,
      totalUsuarios,
      totalAfastados,
      totalDesligados,
      filtrosAtivos,
      limparFiltrosFunc,
      options: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Cadastrados",
          value: true,
        },
        {
          label: "Não Cadastrado",
          value: false,
        },
      ],
    };
  },
};
</script>

<style scoped>
.filtros-container {
  flex-wrap: wrap;
}

.filtro-item {
  margin-left: 8px;
  margin-top: 8px;
}

.botoes-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}

.botao-acao {
  margin-top: 4px;
  margin-left: 8px;
}

@media (max-width: 600px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .filtros-container {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .filtro-item {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin: 0 0 16px 0 !important;
  }

  .filtro-item .q-field {
    width: 100% !important;
  }

  .botoes-container {
    width: 100% !important;
    flex-direction: column !important;
    gap: 12px;
    margin-top: 8px;
  }

  .botao-acao {
    width: 100% !important;
    margin: 0 !important;
    padding: 12px 16px;
    font-size: 14px;
  }

  .q-tabs {
    margin-top: 24px !important;
  }

  .q-tab {
    font-size: 12px !important;
    padding: 8px 4px !important;
  }
}

@media (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .q-page {
    padding: 8px !important;
  }

  .botao-acao {
    font-size: 12px !important;
    padding: 10px 12px;
  }

  .q-tab {
    font-size: 11px !important;
    padding: 6px 2px !important;
  }
}
</style>
